import { Navigate } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useCurrentOrg } from '../hooks/useCurrentOrg';

/**
 * Wrapper à appliquer par-dessus les routes qui nécessitent une organization
 * (typiquement le dashboard). Redirige vers /onboarding si l'user n'en a pas.
 *
 * Doit être imbriqué dans un <ProtectedRoute>.
 */
export function RequireOrg({ children }: { children: ReactNode }) {
    const { org, loading } = useCurrentOrg();

    if (loading) {
        return (
            <div className="app-loader">
                <div className="spinner" aria-hidden />
                <p>Chargement de votre espace…</p>
            </div>
        );
    }

    if (!org) {
        return <Navigate to="/onboarding" replace />;
    }

    return <>{children}</>;
}
